import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonDashboardModule(props) {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data
    return null

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openWindow('/FlowDetail', {prjId, sVer})

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            编辑流程图
        </MenuButton>
    )
}
